<template>
  <div v-if="isDataLoaded" class="individual-page-container">
    <!-- Sidebar - EXACT copy from ProjectSummary -->
    <div class="individual-page-sidebar bak-white-1" :class="isSidebarOpen ? 'open' : 'closed'">
      <ExpandCollapse name="sidebar" :is-open-initially="true" :is-vertical-center="false" open-state="left"
        closed-state="right-zero" :show-double-chevron="true"
        @toggle-expand-collapse="toggleSidebar(); onResizeSidebar()" :show-circle="true" />
      <div :class="!isSidebarOpen ? 'hidden' : ''">
        <div class="project-name">
          <div><strong>{{ companyName }}</strong></div>
          <div class="menu-container">
            <button @click="toggleMenu" class="menu-button">⋮</button>
            <div v-if="isMenuVisible" class="menu-content">
              <ul>
                <li @click="editCompanyDetails">Edit Company Details</li>
                <li @click="editCompanyImage">Edit Company Image</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Sidebar Menu -->
        <div>
          <div class="sidebar-menu">
            <div v-for="item in sidebarMenuItems" :key="item.id"
              :class="{ 'sidebar-menu-selected': item.id === sidebarSelectedItemId }"
              @click="sidebarSelectItem(item.id)">
              {{ item.text }}
            </div>
          </div>
        </div>
        <div ref="companyImageContainer" v-if="sidebarSelectedItemId == 1">
          <div class="project-img">
            <img v-if="companyImage" :src="companyImage" :alt="companyName + ' - Company Logo'">
            <div v-else class="placeholder-image">
              <span>📷</span>
              <p>No company image</p>
            </div>
          </div>
        </div>
        <div v-show="sidebarSelectedItemId == 2">
          <div class="map-container">
            <div v-if="!isCompanyLocationValid">Company has invalid location values.</div>
            <div id="individualPageMap"></div>
          </div>
        </div>
        <div class="project-details-wrapper">
          <div class="project-details">
            <div class="project-img-summary">
              <div class="project-img-summary-item">
                <label>Company Address</label>
                <span>{{ companyAddress }}</span>
              </div>
              <div class="project-img-summary-item">
                <label>City</label><span>{{ companyCity }}</span>
              </div>
              <div class="project-img-summary-item">
                <label>State</label><span>{{ companyState }}</span>
              </div>
              <div class="project-img-summary-item">
                <label>Zip Code</label><span>{{ companyZip }}</span>
              </div>
              <div class="project-img-summary-item construction-type-container">
                <label>Company Type:</label><span>{{ companyTypeDisplay || 'N/A' }}</span>
              </div>
              <div class="project-img-summary-item" v-if="companyEmail">
                <label>Email:</label><span>{{ companyEmail }}</span>
              </div>
              <div class="project-img-summary-item" v-if="companyPhone">
                <label>Phone:</label><span>{{ companyPhone }}</span>
              </div>
              <div class="project-img-summary-item" v-if="companyWebsite">
                <label>Website:</label><span>{{ companyWebsite }}</span>
              </div>
              <div class="project-img-summary-item" v-if="companyLicense">
                <label>License #:</label><span>{{ companyLicense }}</span>
              </div>
              <div class="project-img-summary-item" v-if="companyNotes">
                <label>Notes:</label><span>{{ companyNotes }}</span>
              </div>
            </div>
            <!-- Company Details -->
            <div class="building-details-container">
              <div class="accordion-panel-header">
                <label for="companyDetails"><strong>Company Details</strong></label>
                <ExpandCollapse name="companyDetails" :is-open-initially="true" :is-vertical-center="false"
                  open-state="down" closed-state="up" :show-double-chevron="false" :show-circle="false"
                  :chevron-fill="'#4A5FD5'" @toggle-expand-collapse="expandCollapseController('companyDetails');" />
              </div>
              <div v-if="isCompanyDetailsOpen">
                <div class="building-details-summary">
                  <div class="building-details-summary-item">
                    <label>Total Projects:</label><span>{{ totalProjects }}</span>
                  </div>
                  <div class="building-details-summary-item">
                    <label>Total Value:</label><span>{{ totalValue }}</span>
                  </div>
                  <div class="building-details-summary-item">
                    <label>Avg Budget Variance:</label><span>{{ avgBudgetVariance }}</span>
                  </div>
                  <div class="building-details-summary-item">
                    <label>Avg Schedule Variance:</label><span>{{ avgScheduleVariance }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Content - EXACT copy from ProjectSummary structure -->
    <div class="individal-page-content" :class="!isSidebarOpen ? 'large' : 'small'">
      <div class="breadcrumbs">
        <span @click="navigateToPortfolio" class="breadcrumb-link">← Back</span> | 
        <strong>Company Performance: {{ companyName }}</strong>
      </div>
    
      <div class="individual-page-title">Company Performance: {{ companyName }}</div>
      <div class="individual-page-sub-menu">
        <div v-for="item in subMenuItems" :key="item.id"
          :class="{ 'individual-page-sub-menu-selected': item.id === subMenuSelectedItemId }"
          @click="subMenuSelectItem(item.id)">
          {{ item.name }}
        </div>
    </div>

      <!-- Performance Summary Content -->
      <div v-if="subMenuSelectedItemId == 1">
        <div class="budget-summary-header-container">
          <div class="budget-summary-header-title">Performance Summary</div>
          </div>
        
        <!-- Performance Stats Grid -->
        <div class="overview-stats-grid">
          <div class="stat-tile">
            <div class="stat-title">TOTAL PROJECTS</div>
            <div class="stat-value">{{ totalProjects }}</div>
          </div>
          <div class="stat-tile">
            <div class="stat-title">TOTAL VALUE</div>
            <div class="stat-value">{{ totalValue }}</div>
          </div>
          <div class="stat-tile">
            <div class="stat-title">AVG BUDGET VARIANCE</div>
            <div class="stat-value">{{ avgBudgetVariance }}</div>
          </div>
          </div>

        <!-- 3-Column Portfolio Layout -->
        <div class="dashboard-three-column">
          <div class="dashboard-tile map-tile">
            <div id="contractorDataMap" style="height: 100%"></div>
          </div>
          <div class="dashboard-tile doughnut-tile">
            <div class="tile-header">
              <div class="chart-title">Projects by Asset Class</div>
              <div class="chart-badge">{{ totalProjects }}</div>
            </div>
            <div class="doughnut-container">
              <div class="doughnut-chart-wrapper">
                <Doughnut v-if="doughnutData.labels.length > 0" :height="220" :width="220" :data="doughnutData" :options="doughnutOptions" />
              </div>
              <div class="doughnut-chart-legend">
                <div v-for="(label, index) in doughnutData.labels" :key="index" class="legend-item">
                  <div class="legend-color" :style="{ backgroundColor: doughnutData.datasets[0].backgroundColor[index] }"></div>
                  <div class="legend-label">{{ label }}</div>
                  <div class="legend-value">{{ doughnutData.datasets[0].data[index] }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="dashboard-tile variance-and-starts-tile">
            <div class="tile-header compact-header minimal-header">Variance Summary</div>
            <div class="variance-top-section">
              <div class="variance-chart budget-chart">
                <div class="variance-subtitle">Budget</div>
                <div class="chart-container">
                  <Bar :data="budgetVarianceData" :options="budgetVarianceOptions" />
                </div>
              </div>
              <div class="variance-chart schedule-chart">
                <div class="variance-subtitle">Schedule</div>
                <div class="chart-container">
                  <Bar :data="scheduleVarianceData" :options="scheduleVarianceOptions" />
                </div>
              </div>
            </div>
            
            <div class="project-starts-section">
              <div class="variance-subtitle">Project Starts</div>
              <div class="project-stats-row">
                <span class="stat-text">Avg Projects / Year: <strong>{{ avgProjectsPerYear }}</strong></span>
                <span class="stat-text">Active: <strong>{{ totalProjects }}</strong></span>
              </div>
              <div class="chart-container project-starts-chart">
                <Line v-if="projectStartsData.labels.length > 0" :data="projectStartsData" :options="projectStartsOptions" />
              </div>
            </div>
          </div>
        </div>

        <!-- Projects Grid - Using AgGrid like PortfolioView -->
        <div class="projects-grid-container">
          <h3>Projects</h3>
          <AgGrid
            :full-scroll="true" 
            :override-width="true"
            :row-data="companyProjects" 
            :column-defs="projectColDefs" 
            :key="companyProjects.length" 
            ref="agGridRef"
          />
        </div>
      </div>

      <!-- Detailed Performance Content -->
      <div v-if="subMenuSelectedItemId == 2">
        <div class="budget-summary-header-container">
          <div class="budget-summary-header-title">Detailed Performance Records</div>
          <div style="font-size: 14px; color: #666; margin-top: 8px;">
            All G702 application records for {{ companyName }} across projects
          </div>
        </div>
        
        <!-- Performance Grid -->
        <div class="projects-grid-container">
          <AgGrid
            :full-scroll="true" 
            :override-width="true"
            :row-data="contractorPerformanceData" 
            :column-defs="performanceColDefs" 
            :key="contractorPerformanceData.length" 
            ref="performanceGridRef"
          />
        </div>
      </div>

      <!-- Relationships Content -->
      <div v-if="subMenuSelectedItemId == 3">
        <div class="relationships-overview">
          <div class="section-title">Relationships Overview</div>
          <div class="overview-grid">
            <div class="overview-col">
              <div class="col-title">Capital</div>
              <ol class="link-list">
                <li v-for="(name, idx) in relationships.capital" :key="'cap-'+idx">{{ name }}</li>
                <li v-if="relationships.capital.length === 0" class="muted">N/A</li>
              </ol>
            </div>
            <div class="overview-col">
              <div class="col-title">Management</div>
              <ol class="link-list">
                <li v-for="(name, idx) in relationships.management" :key="'mgmt-'+idx">{{ name }}</li>
                <li v-if="relationships.management.length === 0" class="muted">N/A</li>
              </ol>
            </div>
            <div class="overview-col">
              <div class="col-title">Contractors</div>
              <ol class="link-list">
                <li v-for="(name, idx) in relationships.contractors" :key="'con-'+idx">{{ name }}</li>
                <li v-if="relationships.contractors.length === 0" class="muted">N/A</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>

  <!-- Loading State -->
  <div v-else class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading company data...</p>
          </div>

  <!-- Edit Company Details Modal -->
  <div v-if="showEditDetailsModal" class="modal-backdrop" @click="closeEditDetailsModal">
    <div class="edit-project-modal" @click.stop>
      <div class="modal-header">
        <h3>Edit Company Details</h3>
        <button class="close-button" @click="closeEditDetailsModal">×</button>
          </div>
      <div class="modal-body">
        <div class="form-section">
          <div class="form-row">
            <div class="form-group">
              <label>Company Name</label>
              <input type="text" v-model="editCompanyData.name" class="form-input" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>Company Type</label>
              <select v-model="editCompanyData.company_type" class="form-input">
                <option value="">Select Type...</option>
                <optgroup label="Contractors">
                  <option value="General Contractor">General Contractor</option>
                  <option value="Construction Manager">Construction Manager</option>
                  <option value="Specialty Contractor">Specialty Contractor</option>
                </optgroup>
                <optgroup label="Consultants">
                  <option value="Design Architect">Design Architect</option>
                  <option value="Architect of Record">Architect of Record</option>
                  <option value="Civil Engineer">Civil Engineer</option>
                  <option value="Structural Engineer">Structural Engineer</option>
                  <option value="MEP Engineer">MEP Engineer</option>
                  <option value="Geotechnical Engineer">Geotechnical Engineer</option>
                  <option value="Environmental Engineer">Environmental Engineer</option>
                  <option value="Interior Design">Interior Designer</option>
                  <option value="Landscape Architect">Landscape Architect</option>
                  <option value="Owner's Representative">Owner's Representative</option>
                </optgroup>
                <optgroup label="Investor/Sponsor">
                  <option value="Developer">Developer</option>
                  <option value="Investor">Investor</option>
                  <option value="Owner">Owner</option>
                </optgroup>
              </select>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>Address</label>
              <input type="text" v-model="editCompanyData.address" class="form-input" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>City</label>
              <input type="text" v-model="editCompanyData.city" class="form-input" />
            </div>
            <div class="form-group">
              <label>State</label>
              <input type="text" v-model="editCompanyData.state" class="form-input" />
            </div>
            <div class="form-group">
              <label>Zip Code</label>
              <input type="text" v-model="editCompanyData.zip" class="form-input" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>Email</label>
              <input type="email" v-model="editCompanyData.email" class="form-input" />
            </div>
            <div class="form-group">
              <label>Phone</label>
              <input type="tel" v-model="editCompanyData.phone" class="form-input" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>Website</label>
              <input type="url" v-model="editCompanyData.website" class="form-input" placeholder="https://" />
            </div>
            <div class="form-group">
              <label>License Number</label>
              <input type="text" v-model="editCompanyData.license_number" class="form-input" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="editCompanyData.notes" class="form-input" rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-secondary" @click="closeEditDetailsModal">Cancel</button>
        <button class="btn-primary" @click="saveCompanyDetails">Save Changes</button>
        </div>
      </div>
    </div>

  <!-- Edit Company Image Modal -->
  <div v-if="showEditImageModal" class="modal-backdrop" @click="closeEditImageModal">
    <div class="edit-images-modal" @click.stop>
      <div class="modal-header">
        <h3>Edit Company Image</h3>
        <button class="close-button" @click="closeEditImageModal">×</button>
      </div>
      <div class="modal-body">
        <div class="upload-section">
          <label class="upload-button" for="company-image-upload">
            Choose Company Logo
          </label>
          <input 
            type="file" 
            id="company-image-upload" 
            @change="handleImageUpload" 
            accept="image/*" 
            style="display: none;"
          />
          <p class="upload-hint">Upload a company logo (JPG, PNG, GIF)</p>
        </div>
        
        <div v-if="companyImage" class="images-section">
          <h4>Current Company Image</h4>
          <div class="images-grid">
            <div class="image-item">
              <div class="image-preview">
                <img :src="companyImage" :alt="companyName + ' Logo'" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer split">
        <div class="left">
          <button class="btn-secondary" @click="closeEditImageModal">Cancel</button>
        </div>
        <div class="right">
          <button class="btn-primary" @click="saveCompanyImage">Save Image</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useDropdownStore } from '@/stores/dropdown_store'
import { useAuthStore } from '@/stores/auth_store'
import ExpandCollapse from '@/components/helpers/ExpandCollapse.vue'
import AgGrid from '@/components/AgGrid.vue'
import { Doughnut, Bar, Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler)
import { loadGoogleMapsAPI } from '@/main.js'
import { geocodeAddress } from '@/services/geocodingService'
import DDADataService from '@/services/ddaDataService'
import { axiosQuery } from '@/assets/js/utils'

const route = useRoute()
// Accept router-provided props to avoid extraneous non-props warnings
// (we still read from route.params for consistency across pages)
defineProps({ type: String, id: [String, Number] })
const router = useRouter()
const dropdownStore = useDropdownStore()
const authStore = useAuthStore()

// API configuration (use the same base as the rest of the app)
const apiBase = process.env.VUE_APP_ENV_API_BASE || "http://167.172.25.255:3000/api/v1/"
const authToken = computed(() => authStore.getAuthTokenHeader)

// Route parameters
const companyType = ref(route.params.type || 'contractors')
const companyId = ref(route.params.id)

// Loading and UI state
const isDataLoaded = ref(false)
const isSidebarOpen = ref(true)
const largeSidebar = ref(true)
const isMenuVisible = ref(false)

// Google Maps state
const isGoogleMapsMounted = ref(false)

// Modal states
const showEditDetailsModal = ref(false)
const showEditImageModal = ref(false)
const editCompanyData = ref({
  name: '',
  address: '',
  city: '',
  state: '',
  zip: ''
})

// Sidebar state
const sidebarSelectedItemId = ref(1)
const sidebarMenuItems = ref([
  { id: 1, text: 'Photo' },
  { id: 2, text: 'Map' }
])

// Sub menu state
const subMenuSelectedItemId = ref(1)
const subMenuItems = ref([
  { id: 1, name: 'Projects & Performance' },
  { id: 2, name: 'Detailed Performance' },
  { id: 3, name: 'Relationships' }
])

// Detailed performance data
const contractorPerformanceData = ref([])
const performanceColDefs = ref([
  {
    headerName: 'Project',
    field: 'project_name',
    width: 180,
    cellRenderer: (params) => {
      if (params.value && params.data.project_id) {
        return `<a href="/projects/${params.data.project_id}" style="color: #4A5FD5; text-decoration: none;">${params.value}</a>`
      }
      return params.value || 'N/A'
    }
  },
  {
    headerName: 'Application #',
    field: 'application_number',
    width: 110
  },
  {
    headerName: 'Draw #',
    field: 'draw_number',
    width: 80
  },
  {
    headerName: 'Period Through',
    field: 'period_through',
    width: 120,
    valueFormatter: (params) => {
      if (params.value) {
        const date = new Date(params.value)
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      }
      return 'N/A'
    }
  },
  {
    headerName: 'Budget (Current)',
    field: 'contract_sum_to_date',
    width: 130,
    valueFormatter: (params) => {
      const value = parseFloat(params.value || 0)
      if (value > 0) {
        return `$${(value / 1000000).toFixed(1)}M`
      }
      return '$0.0M'
    }
  },
  {
    headerName: 'Billed to Date',
    field: 'total_earned_less_retainage',
    width: 130,
    valueFormatter: (params) => {
      const value = parseFloat(params.value || 0)
      if (value > 0) {
        return `$${(value / 1000000).toFixed(1)}M`
      }
      return '$0.0M'
    }
  },
  {
    headerName: '% Complete',
    field: 'completion_percentage',
    width: 110,
    valueGetter: (params) => {
      const budget = parseFloat(params.data.contract_sum_to_date || 0)
      const billed = parseFloat(params.data.total_earned_less_retainage || 0)
      if (budget > 0) {
        return (billed / budget) * 100
      }
      return 0
    },
    valueFormatter: (params) => {
      const value = params.value || 0
      return `${value.toFixed(1)}%`
    }
  },
  {
    headerName: 'Variance ($)',
    field: 'budget_variance_amount',
    width: 120,
    valueGetter: (params) => {
      const original = parseFloat(params.data.original_contract_sum || 0)
      const current = parseFloat(params.data.contract_sum_to_date || 0)
      return current - original
    },
    valueFormatter: (params) => {
      const value = params.value || 0
      const sign = value >= 0 ? '+' : ''
      return `${sign}$${(value / 1000).toFixed(0)}K`
    },
    cellStyle: (params) => {
      const value = params.value || 0
      return value > 0 ? { color: '#FF6B6B' } : { color: '#4ECDC4' }
    }
  },
  {
    headerName: 'Variance (%)',
    field: 'budget_variance_pct',
    width: 120,
    valueGetter: (params) => {
      const original = parseFloat(params.data.original_contract_sum || 0)
      const current = parseFloat(params.data.contract_sum_to_date || 0)
      if (original > 0) {
        return ((current - original) / original) * 100
      }
      return 0
    },
    valueFormatter: (params) => {
      const value = params.value || 0
      const sign = value >= 0 ? '+' : ''
      return `${sign}${value.toFixed(1)}%`
    },
    cellStyle: (params) => {
      const value = params.value || 0
      return value > 0 ? { color: '#FF6B6B' } : { color: '#4ECDC4' }
    }
  },
  {
    headerName: 'DDA Term',
    field: 'dda_term',
    width: 200,
    valueFormatter: (params) => {
      return params.value || 'Not Assigned'
    }
  }
])

// Company details expansion
const isCompanyDetailsOpen = ref(true)

// Company data
const companyName = ref('Loading...')
const companyImage = ref('')
const selectedImageFile = ref(null)
const companyAddress = ref('')
const companyCity = ref('')
const companyState = ref('')
const companyZip = ref('')
const companySpecialties = ref('')
const companyTypeDisplay = ref('') // Actual company type from database
const companyEmail = ref('')
const companyPhone = ref('')
const companyWebsite = ref('')
const companyLicense = ref('')
const companyNotes = ref('')
const isCompanyLocationValid = ref(false)

// Projects data
const companyProjects = ref([])

// Chart data
const doughnutData = computed(() => {
  if (!companyProjects.value.length) {
    // Return sample data if no projects loaded yet
    return {
      labels: ['Residential', 'Commercial'],
      datasets: [{
        data: [1, 1],
        backgroundColor: ['#3b82f6', '#10b981']
      }]
    }
  }
  
  const assetTypes = {}
  companyProjects.value.forEach(project => {
    const type = project.primary_use_type || 'Mixed Use'
    assetTypes[type] = (assetTypes[type] || 0) + 1
  })
  
  return {
    labels: Object.keys(assetTypes),
    datasets: [{
      data: Object.values(assetTypes),
      backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6']
    }]
  }
})

const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } }
}

// Budget Variance chart data (top 5 projects)
const budgetVarianceData = computed(() => {
  if (!companyProjects.value.length) {
    return {
      labels: [],
      datasets: [{
        label: 'Budget Variance',
        data: [],
        backgroundColor: '#84CADE'
      }]
    }
  }
  
  // Get top 5 projects by absolute budget variance
  const projectData = companyProjects.value
    .filter(p => p.currentBudget > 0 && p.budgetVariance !== undefined)
    .map(project => ({
      name: project.name || `Project ${project.id}`,
      variance: parseFloat(project.budgetVariance) || 0
    }))
    .sort((a, b) => Math.abs(b.variance) - Math.abs(a.variance))
    .slice(0, 5)
  
  return {
    labels: projectData.map(p => p.name.length > 15 ? p.name.substring(0, 15) + '...' : p.name),
    datasets: [{
      label: 'Budget Variance',
      data: projectData.map(p => p.variance),
      backgroundColor: '#84CADE'
    }]
  }
})

const budgetVarianceOptions = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { top: 15 }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (context) => `${context.parsed.x > 0 ? '+' : ''}${context.parsed.x.toFixed(1)}%`
      }
    }
  },
  scales: {
    x: {
      grid: { drawBorder: false },
      ticks: {
        callback: (value) => value + '%',
        font: { size: 10 }
      }
    },
    y: {
      grid: { display: false },
      ticks: {
        font: { size: 10 },
        autoSkip: false
      }
    }
  }
}

// Schedule Variance chart data (top 5 projects)
const scheduleVarianceData = computed(() => {
  if (!companyProjects.value.length) {
    return {
      labels: [],
      datasets: [{
        label: 'Schedule Variance',
        data: [],
        backgroundColor: '#84CADE'
      }]
    }
  }
  
  // Get top 5 projects by absolute schedule variance
  const projectData = companyProjects.value
    .filter(p => p.scheduleVariance !== undefined && p.scheduleVariance !== 0)
    .map(project => ({
      name: project.name || `Project ${project.id}`,
      variance: parseFloat(project.scheduleVariance) || 0
    }))
    .sort((a, b) => Math.abs(b.variance) - Math.abs(a.variance))
    .slice(0, 5)
  
  // If no schedule variance data, show placeholder
  if (projectData.length === 0) {
    return {
      labels: ['No schedule data'],
      datasets: [{
        label: 'Schedule Variance',
        data: [0],
        backgroundColor: '#e5e7eb'
      }]
    }
  }
  
  return {
    labels: projectData.map(p => p.name.length > 15 ? p.name.substring(0, 15) + '...' : p.name),
    datasets: [{
      label: 'Schedule Variance',
      data: projectData.map(p => p.variance),
      backgroundColor: '#84CADE'
    }]
  }
})

const scheduleVarianceOptions = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { top: 15 }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (context) => `${context.parsed.x > 0 ? '+' : ''}${context.parsed.x.toFixed(0)} months`
      }
    }
  },
  scales: {
    x: {
      grid: { drawBorder: false },
      ticks: {
        callback: (value) => value + 'mo',
        font: { size: 10 }
      }
    },
    y: {
      grid: { display: false },
      ticks: {
        font: { size: 10 },
        autoSkip: false
      }
    }
  }
}

// Contractor Project Starts chart data
const projectStartsData = computed(() => {
  if (!companyProjects.value.length) {
    return {
      labels: [],
      datasets: [{
        label: 'Project Starts',
        data: [],
        backgroundColor: '#A0D1FF',
        borderColor: '#3CA1FB',
        fill: true
      }]
    }
  }
  
  // Extract years from project start dates
  const projectYears = companyProjects.value
    .filter(p => p.actual_start_date)
    .map(project => new Date(project.actual_start_date).getFullYear())
    .filter(year => year && year !== 1970 && year > 2000)
  
  // Count projects per year
  const projectCountPerYear = projectYears.reduce((acc, year) => {
    acc[year] = (acc[year] || 0) + 1
    return acc
  }, {})
  
  // Sort years and prepare data
  const sortedYears = Object.keys(projectCountPerYear).sort((a, b) => a - b)
  
  // If we have less than 5 years, add some padding years
  if (sortedYears.length > 0) {
    const minYear = parseInt(sortedYears[0])
    const maxYear = parseInt(sortedYears[sortedYears.length - 1])
    const currentYear = new Date().getFullYear()
    
    // Ensure we show at least 5 years
    for (let year = Math.max(minYear - 1, currentYear - 4); year <= currentYear; year++) {
      if (!projectCountPerYear[year]) {
        projectCountPerYear[year] = 0
      }
    }
  }
  
  const finalSortedYears = Object.keys(projectCountPerYear).sort((a, b) => a - b)
  
  return {
    labels: finalSortedYears,
    datasets: [{
      label: 'Project Starts',
      data: finalSortedYears.map(year => projectCountPerYear[year]),
      backgroundColor: '#A0D1FF',
      borderColor: '#3CA1FB',
      fill: true,
      tension: 0.4,
      pointRadius: 5,
      pointBackgroundColor: '#3CA1FB'
    }]
  }
})

const projectStartsOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 20,
      left: 10,
      right: 10,
      bottom: 10
    }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (context) => {
          return `Projects Started: ${context.parsed.y}`
        }
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      ticks: {
        font: { size: 10 }
      }
    },
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
        font: { size: 10 },
        callback: (value) => {
          if (Math.floor(value) === value) {
            return value
          }
        }
      }
    }
  }
}
const agGridRef = ref(null)
const performanceGridRef = ref(null)
const relationships = reactive({ capital: [], management: [], contractors: [] })

// Performance metrics - use cached stats for non-contractors, project count for contractors
const cachedStats = ref({ total_projects_count: 0, total_original_budget: 0, avg_budget_variance_percent: 0 })
const totalProjects = computed(() => {
  if (companyType.value === 'contractors') {
    return companyProjects.value.length
  } else {
    return cachedStats.value.total_projects_count || 0
  }
})
const totalValue = computed(() => {
  if (companyType.value === 'contractors') {
    const total = companyProjects.value.reduce((sum, project) => {
      // Use currentBudget from the enhanced project data - this is what shows in the grid
      return sum + (project.currentBudget || 0)
    }, 0)
    return `$${(total / 1000000).toFixed(1)}M`
  } else {
    const total = parseFloat(cachedStats.value.total_original_budget || 0)
    return `$${(isNaN(total) ? 0 : total / 1000000).toFixed(1)}M`
  }
})
const avgBudgetVariance = computed(() => {
  if (companyType.value === 'contractors') {
    if (companyProjects.value.length === 0) return '0.0%'
    const avg = companyProjects.value.reduce((sum, project) => {
      return sum + (project.budgetVariance || 0)
    }, 0) / companyProjects.value.length
    return `${avg.toFixed(1)}%`
  } else {
    const value = parseFloat(cachedStats.value.avg_budget_variance_percent || 0)
    return `${isNaN(value) ? 0 : value.toFixed(1)}%`
  }
})
const avgScheduleVariance = computed(() => {
  if (companyType.value === 'contractors') {
    if (companyProjects.value.length === 0) return '0.0%'
    const avg = companyProjects.value.reduce((sum, project) => {
      return sum + (project.scheduleVariance || 0)
    }, 0) / companyProjects.value.length
    return `${avg.toFixed(1)}%`
  } else {
    const value = parseFloat(cachedStats.value.avg_schedule_variance_percent || 0)
    return `${isNaN(value) ? 0 : value.toFixed(1)}%`
  }
})

const avgProjectsPerYear = computed(() => {
  if (!companyProjects.value.length) return '0'
  
  const years = companyProjects.value
    .filter(p => p.actual_start_date)
    .map(p => new Date(p.actual_start_date).getFullYear())
    .filter(year => year && year > 2000)
  
  if (!years.length) return '0'
  
  const uniqueYears = [...new Set(years)]
  return (companyProjects.value.length / uniqueYears.length).toFixed(1)
})

const activeSince = computed(() => {
  const years = companyProjects.value
    .filter(p => p.actual_start_date)
    .map(p => new Date(p.actual_start_date).getFullYear())
    .filter(year => year && year > 2000)
  
  if (!years.length) return 'N/A'
  
  return Math.min(...years).toString()
})

// AG-Grid column definitions with real G702 performance data
const projectColDefs = ref([
  {
    headerName: 'Project Name',
    field: 'name',
    width: 200,
    cellRenderer: (params) => {
      if (params.value) {
        return `<a href="/projects/${params.data.id}" style="color: #4A5FD5; text-decoration: none;">${params.value}</a>`
      }
      return 'N/A'
    }
  },
  {
    headerName: 'Budget (Current)',
    field: 'total_current_budget',
    width: 130,
    valueFormatter: (params) => {
      if (params.value && params.value > 0) {
        return `$${(params.value / 1000000).toFixed(1)}M`
      }
      return '$0.0M'
    }
  },
  {
    headerName: 'Billed to Date',
    field: 'total_billed_to_date',
    width: 130,
    valueFormatter: (params) => {
      if (params.value && params.value > 0) {
        return `$${(params.value / 1000000).toFixed(1)}M`
      }
      return '$0.0M'
    }
  },
  {
    headerName: '% Complete',
    field: 'completionPct',
    width: 110,
    valueFormatter: (params) => {
      const value = params.value || 0
      return `${value.toFixed(1)}%`
    }
  },
  {
    headerName: 'Budget Variance',
    field: 'budgetVariance',
    width: 150,
    cellRenderer: (params) => {
      const variance = params.value || 0
      const color = variance > 0 ? '#FF6B6B' : '#4ECDC4'
      const width = Math.min(Math.abs(variance), 100)
      return `
        <div style="display: flex; align-items: center;">
          <div style="background-color: ${color}; height: 20px; width: ${width}%; margin-right: 8px; border-radius: 2px;"></div>
          <span>${variance.toFixed(1)}%</span>
        </div>
      `
    }
  },
  {
    headerName: 'Latest Activity',
    field: 'latestPeriod',
    width: 120,
    valueFormatter: (params) => {
      if (params.value) {
        const date = new Date(params.value)
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      }
      return 'N/A'
    }
  },
  {
    headerName: 'G702 Records',
    field: 'g702RecordCount',
    width: 110,
    valueFormatter: (params) => {
      return params.value || 0
    }
  },
  {
    headerName: 'City',
    field: 'city',
    width: 100
  },
  {
    headerName: 'State',
    field: 'state',
    width: 80
  },
  {
    headerName: 'Primary Use Type',
    field: 'primary_building_use_type',
    width: 150
  },
  {
    headerName: 'Lender',
    field: 'lender',
    width: 120
  },
  {
    headerName: 'Developer',
    field: 'developer',
    width: 120
  }
])

// Functions
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value
}

const onResizeSidebar = () => {
  largeSidebar.value = isSidebarOpen.value
}

const toggleMenu = () => {
  isMenuVisible.value = !isMenuVisible.value
}

const sidebarSelectItem = (id) => {
  sidebarSelectedItemId.value = id
}

const subMenuSelectItem = (id) => {
  subMenuSelectedItemId.value = id
}

const expandCollapseController = (section) => {
  if (section === 'companyDetails') {
    isCompanyDetailsOpen.value = !isCompanyDetailsOpen.value
  }
}

const editCompanyDetails = () => {
  console.log('Edit company details')
  isMenuVisible.value = false
  
  // Populate edit form with current data
  editCompanyData.value = {
    name: companyName.value,
    company_type: companyTypeDisplay.value !== 'N/A' ? companyTypeDisplay.value : '',
    address: companyAddress.value !== 'N/A' ? companyAddress.value : '',
    city: companyCity.value !== 'N/A' ? companyCity.value : '',
    state: companyState.value !== 'N/A' ? companyState.value : '',
    zip: companyZip.value !== 'N/A' ? companyZip.value : '',
    email: companyEmail.value,
    phone: companyPhone.value,
    website: companyWebsite.value,
    license_number: companyLicense.value,
    notes: companyNotes.value
  }
  
  showEditDetailsModal.value = true
}

const editCompanyImage = () => {
  console.log('Edit company image')
  isMenuVisible.value = false
  showEditImageModal.value = true
}

const closeEditDetailsModal = () => {
  showEditDetailsModal.value = false
}

const closeEditImageModal = () => {
  showEditImageModal.value = false
}

const saveCompanyDetails = async () => {
  try {
    const updateData = {
      name: editCompanyData.value.name,
      address_line_1: editCompanyData.value.address,
      city: editCompanyData.value.city,
      state: editCompanyData.value.state,
      zipcode: editCompanyData.value.zip,
      email: editCompanyData.value.email,
      phone: editCompanyData.value.phone,
      website: editCompanyData.value.website,
      license_number: editCompanyData.value.license_number,
      notes: editCompanyData.value.notes
    }
    
    // Add type-specific field for company type
    if (companyType.value === 'contractors') {
      updateData.contractor_type = editCompanyData.value.company_type
    } else if (companyType.value === 'consultants') {
      updateData.consultant_type = editCompanyData.value.company_type
    }

    // Map resource + wrapper by company type
    let resource = 'contractors'
    let wrapper = null // Contractors don't use wrapper
    if (companyType.value === 'investor_sponsors') { resource = 'investor_sponsors'; wrapper = 'investor_sponsor' }
    if (companyType.value === 'consultants') { resource = 'consultants'; wrapper = 'consultant' }

    // Wrap payload if needed (consultants/investor_sponsors), send flat for contractors
    const payload = wrapper ? { [wrapper]: updateData } : updateData

    console.log('📤 Saving company details:', payload)

    const response = await fetch(`${apiBase}${resource}/${companyId.value}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })

    if (response.ok) {
      console.log('✅ Company details saved successfully')
      closeEditDetailsModal()
      
      // Reload company data to reflect changes
      await loadCompanyInfo()
      loadGoogleMapsFromAddress()
      
      alert('Company details saved successfully!')
    } else {
      const err = await response.text()
      console.error('❌ Failed to save company details:', response.status, err)
      alert('Error saving company details: ' + err)
    }
  } catch (error) {
    console.error('❌ Error saving company details:', error)
    alert('Error saving company details: ' + error.message)
  }
}

const handleImageUpload = (event) => {
  const file = event.target.files[0]
  if (file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      companyImage.value = e.target.result
    }
    reader.readAsDataURL(file)
    selectedImageFile.value = file
  }
}

const saveCompanyImage = async () => {
  try {
    // Upload to documents storage
    let uploadedUrl = ''
    if (selectedImageFile.value) {
      const formData = new FormData()
      formData.append('document[file]', selectedImageFile.value)
      formData.append('document[document_type]', 'company_image')
      formData.append('document[description]', companyName.value || 'Company Image')
      formData.append('document[metadata]', JSON.stringify({ company_id: companyId.value, company_type: companyType.value }))

      const resp = await fetch(`${apiBase}documents`, { method: 'POST', body: formData })
      const data = await resp.json().catch(() => ({}))
      uploadedUrl = data?.url || data?.document?.url || data?.data?.url || ''
      if (!uploadedUrl) {
        const stack = [data]
        while (stack.length) {
          const obj = stack.pop()
          if (!obj || typeof obj !== 'object') continue
          if (typeof obj.url === 'string') { uploadedUrl = obj.url; break }
          Object.values(obj).forEach(v => { if (v && typeof v === 'object') stack.push(v) })
        }
      }
      if (uploadedUrl) companyImage.value = uploadedUrl
    }

    // Persist URL on company
    if (companyImage.value) {
      let resource = 'contractors'
      let wrapper = null // Contractors don't use wrapper
      if (companyType.value === 'investor_sponsors') { resource = 'investor_sponsors'; wrapper = 'investor_sponsor' }
      if (companyType.value === 'consultants') { resource = 'consultants'; wrapper = 'consultant' }
      
      const payload = wrapper ? { [wrapper]: { image_url: companyImage.value } } : { image_url: companyImage.value }
      
      await fetch(`${apiBase}${resource}/${companyId.value}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(() => {})
    }

    closeEditImageModal()
  } catch (error) {
    console.error('❌ Error saving company image:', error)
    closeEditImageModal()
  }
}

// Load investor sponsor projects using OwnerAllocation data (matches Directory stats)
const loadInvestorSponsorProjects = async () => {
  try {
    console.log(`🔍 Loading investor sponsor projects for ${companyName.value} (ID: ${companyId.value})...`)
    
    // Get investor sponsor details (includes cached stats like Directory uses)
    let sponsorData = null
    await new Promise((resolve) => {
      axiosQuery(
        `${apiBase}investor_sponsors/${companyId.value}`,
        authToken,
        (response) => {
          sponsorData = response
          resolve()
        },
        (error) => {
          console.error(`❌ API error getting investor sponsor details:`, error)
          resolve()
        }
      )
    })
    
    if (sponsorData) {
      console.log(`📊 Investor sponsor stats - Projects: ${sponsorData.total_projects_count || 0}, Budget: $${sponsorData.total_original_budget || 0}`)
      
      // Update cached stats to match Directory (used by computed properties)
      cachedStats.value = {
        total_projects_count: sponsorData.total_projects_count || 0,
        total_original_budget: sponsorData.total_original_budget || 0,
        avg_budget_variance_percent: sponsorData.avg_budget_variance_percent || 0,
        avg_schedule_variance_percent: sponsorData.avg_schedule_variance_percent || 0
      }
      
      console.log(`📊 Updated cached stats for investor sponsor`)
      
      // Now get the actual projects list for the grid and map
      let projectsData = null
      await new Promise((resolve) => {
        axiosQuery(
          `${apiBase}investor_sponsors/${companyId.value}/projects`,
          authToken,
          (response) => {
            projectsData = response
            resolve()
          },
          (error) => {
            console.error(`❌ API error getting investor sponsor projects:`, error)
            resolve()
          }
        )
      })
      
      if (projectsData && projectsData.projects) {
        console.log(`📋 Found ${projectsData.projects.length} actual projects for investor sponsor`)
        companyProjects.value = projectsData.projects
        
        // Build relationships overview for investor sponsors
        // Count frequency of each collaborator across projects
        try {
          const capitalCounts = new Map()
          const managementCounts = new Map()
          const contractorCounts = new Map()

          projectsData.projects.forEach(p => {
            if (p.lender && p.lender !== companyName.value) {
              capitalCounts.set(p.lender, (capitalCounts.get(p.lender) || 0) + 1)
            }
            if (p.developer && p.developer !== companyName.value) {
              managementCounts.set(p.developer, (managementCounts.get(p.developer) || 0) + 1)
            }
            // TODO: Get actual contractors from project data when available
            // For now, we'll populate this later when we have G702 contractor data
          })

          // Get top 5 most frequent collaborators for each category
          relationships.capital = Array.from(capitalCounts.entries())
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([name, count]) => `${name} (${count})`)
            
          relationships.management = Array.from(managementCounts.entries())
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([name, count]) => `${name} (${count})`)
            
          relationships.contractors = Array.from(contractorCounts.entries())
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([name, count]) => `${name} (${count})`)
            
          console.log(`🤝 Built relationships - Capital: ${relationships.capital.length}, Management: ${relationships.management.length}, Contractors: ${relationships.contractors.length}`)
        } catch (error) {
          console.error('❌ Error building relationships:', error)
        }
        
        // Initialize the projects map after loading data
        setTimeout(() => {
          initializeContractorProjectsMap()
        }, 500)
      } else {
        console.log('📋 No projects list found for investor sponsor')
        companyProjects.value = []
      }
    } else {
      console.log('📊 No data found for investor sponsor')
      companyProjects.value = []
    }
    
  } catch (error) {
    console.error('❌ Error loading investor sponsor projects:', error)
    companyProjects.value = []
  }
}

// Load consultant projects using ConsultantProject data (matches Directory stats)
const loadConsultantProjects = async () => {
  try {
    console.log(`🔍 Loading consultant projects for ${companyName.value} (ID: ${companyId.value})...`)
    
    // Get consultant details (includes cached stats like Directory uses)
    let consultantData = null
    await new Promise((resolve) => {
      axiosQuery(
        `${apiBase}consultants/${companyId.value}`,
        authToken,
        (response) => {
          consultantData = response
          resolve()
        },
        (error) => {
          console.error(`❌ API error getting consultant details:`, error)
          resolve()
        }
      )
    })
    
    if (consultantData) {
      console.log(`📊 Consultant stats - Projects: ${consultantData.total_projects_count || 0}, Budget: $${consultantData.total_original_budget || 0}`)
      
      // Update cached stats to match Directory (used by computed properties)
      cachedStats.value = {
        total_projects_count: consultantData.total_projects_count || 0,
        total_original_budget: consultantData.total_original_budget || 0,
        avg_budget_variance_percent: consultantData.avg_budget_variance_percent || 0,
        avg_schedule_variance_percent: consultantData.avg_schedule_variance_percent || 0
      }
      
      // For now, clear projects list (use stats instead)
      // TODO: Add consultant projects endpoint similar to investor sponsors
      companyProjects.value = []
      
      console.log(`📊 Updated cached stats for consultant`)
    } else {
      console.log('📊 No data found for consultant')
      companyProjects.value = []
    }
    
  } catch (error) {
    console.error('❌ Error loading consultant projects:', error)
    companyProjects.value = []
  }
}

// Initialize contractor projects map
const initializeContractorProjectsMap = () => {
  if (!window.google || !window.google.maps) {
    console.log('⚠️ Google Maps not loaded, waiting...')
    return
  }

  const mapElement = document.getElementById('contractorDataMap')
  if (!mapElement) {
    console.log('⚠️ contractorDataMap element not found')
    return
  }

  // Initialize map centered on NYC
  const map = new google.maps.Map(mapElement, {
    center: { lat: 40.7580, lng: -73.9855 },
    zoom: 11,
    mapTypeId: 'terrain',
    styles: [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "on" }]
      }
    ]
  })

  // Add markers for each project
  companyProjects.value.forEach(project => {
    if (project.latitude && project.longitude) {
      const marker = new google.maps.Marker({
        position: { lat: parseFloat(project.latitude), lng: parseFloat(project.longitude) },
        map: map,
        title: project.name || 'Project',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: '#3b82f6',
          fillOpacity: 0.8,
          strokeColor: '#1e40af',
          strokeWeight: 2
        }
      })

      // Add info window
      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div style="padding: 8px;">
            <h4 style="margin: 0 0 4px 0; font-weight: 600;">${project.name || 'Project'}</h4>
            <p style="margin: 0; font-size: 14px;">Budget: ${project.currentBudget ? '$' + (project.currentBudget / 1000000).toFixed(1) + 'M' : 'N/A'}</p>
          </div>
        `
      })

      marker.addListener('click', () => {
        infoWindow.open(map, marker)
      })
    }
  })

  // Fit map to show all markers
  if (companyProjects.value.length > 0) {
    const bounds = new google.maps.LatLngBounds()
    companyProjects.value.forEach(project => {
      if (project.latitude && project.longitude) {
        bounds.extend({ lat: parseFloat(project.latitude), lng: parseFloat(project.longitude) })
      }
    })
    if (!bounds.isEmpty()) {
      map.fitBounds(bounds)
    }
  }
}

// Google Maps functions
const loadGoogleMapsFromAddress = () => {
  if (!isGoogleMapsMounted.value) {
    console.log('⚠️ Google Maps not yet mounted, skipping geocoding')
    return
  }

  const addressParts = []
  if (companyAddress.value) addressParts.push(companyAddress.value)
  if (companyCity.value) addressParts.push(companyCity.value)
  if (companyState.value) addressParts.push(companyState.value)
  if (companyZip.value) addressParts.push(companyZip.value)

  if (addressParts.length === 0) {
    console.log('⚠️ No address components available for geocoding')
    isCompanyLocationValid.value = false
    return
  }

  const fullAddress = addressParts.join(', ')
  console.log('🌍 Geocoding company address:', fullAddress)

  geocodeAddress({
    address_line_1: companyAddress.value,
    city: companyCity.value,
    state: companyState.value,
    zipcode: companyZip.value
  }).then(coords => {
    if (!coords) { isCompanyLocationValid.value = false; return }
    loadGoogleMapsWithCoordinates(coords.latitude, coords.longitude)
  }).catch(() => { isCompanyLocationValid.value = false })
}

const loadGoogleMapsWithCoordinates = (lat, lng) => {
  isCompanyLocationValid.value = true
  
  const mapContainer = document.getElementById('individualPageMap')
  if (!mapContainer) {
    console.error('❌ Map container not found')
    return
  }

  const map = new google.maps.Map(mapContainer, {
    center: { lat, lng },
    zoom: 15,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false
  })
    
  // Add marker for company location
  const marker = new google.maps.Marker({
    position: { lat, lng },
    map: map,
    title: companyName.value
  })

  console.log('✅ Google Maps loaded with company location')
}

const loadGoogleMaps = async () => {
  console.log('🗺️ loadGoogleMaps called')
  console.log('🗺️ Google Maps API available:', typeof google !== 'undefined')
  console.log('🗺️ Company address components:', {
    address: companyAddress.value,
    city: companyCity.value,
    state: companyState.value,
    zip: companyZip.value
  })
  
  // Default coordinates (NYC)
  const defaultLat = 40.7549
  const defaultLng = -73.9840
  
  try {
    // try geocoding immediately if we already have fields
    const coords = await geocodeAddress({
      address_line_1: companyAddress.value,
      city: companyCity.value,
      state: companyState.value,
      zipcode: companyZip.value
    })
    if (coords) {
      loadGoogleMapsWithCoordinates(coords.latitude, coords.longitude)
      isGoogleMapsMounted.value = true
      return
    }
  } catch (e) { /* fall back to default */ }

  loadGoogleMapsWithCoordinates(defaultLat, defaultLng)
  
  isGoogleMapsMounted.value = true
  console.log('🗺️ Google Maps mounted flag set to true')
  
  // Try to geocode actual company address
  setTimeout(() => {
    console.log('🗺️ Attempting to geocode company address after delay')
    loadGoogleMapsFromAddress()
  }, 500)
}

const navigateToPortfolio = () => {
  router.back() // Go back to previous page instead of hardcoded Portfolio
}

async function fetchCompanyById(resource, id) {
  try {
    const res = await fetch(`${apiBase}${resource}/${id}`)
    if (!res.ok) return null
    return await res.json()
  } catch (e) { return null }
}

// Load company information
const loadCompanyInfo = async () => {
  try {
    console.log(`🔍 Loading company info for type: ${companyType.value}, id: ${companyId.value}`)
    
    let companyData = null
    
    if (companyType.value === 'contractors') {
      // Try direct API by id first
      const rec = await fetchCompanyById('contractors', companyId.value)
      if (rec) {
        companyName.value = rec.name || rec.entity_name || `Company ${companyId.value}`
        companyData = rec
      } else {
        // Fallback to store
        await dropdownStore.getGeneralContractors()
        const contractor = dropdownStore.generalContractors.find(c => c.id == companyId.value)
        companyName.value = contractor?.name || contractor?.entity_name || `Company ${companyId.value}`
        companyData = contractor
      }
    } else if (companyType.value === 'investor_sponsors') {
      const rec = await fetchCompanyById('investor_sponsors', companyId.value)
      if (rec) {
        companyName.value = rec.name || rec.company_name || `Company ${companyId.value}`
        companyData = rec
      } else {
        await dropdownStore.getInvestorSponsors?.()
        const list = dropdownStore.investorSponsors || []
        const found = list.find(c => c.id == companyId.value)
        companyName.value = found?.name || `Company ${companyId.value}`
        companyData = found
      }
    } else if (companyType.value === 'consultants') {
      const rec = await fetchCompanyById('consultants', companyId.value)
      if (rec) {
        companyName.value = rec.name || `Company ${companyId.value}`
        companyData = rec
      } else {
        await dropdownStore.getConsultants?.()
        const list = dropdownStore.consultants || []
        const found = list.find(c => c.id == companyId.value)
        companyName.value = found?.name || `Company ${companyId.value}`
        companyData = found
      }
    } else {
      companyName.value = `Company ${companyId.value}`
    }
    
    // Set company details from actual database record
    if (companyData) {
      companyAddress.value = companyData.address_line_1 || companyData.address || 'N/A'
      companyCity.value = companyData.city || 'N/A'
      companyState.value = companyData.state || 'N/A'
      companyZip.value = companyData.zipcode || companyData.zip || 'N/A'
      // Use company_type from serializer (works for all company types: contractors, consultants, investors)
      companyTypeDisplay.value = companyData.company_type || companyData.contractor_type || 'N/A'
      companyEmail.value = companyData.email || ''
      companyPhone.value = companyData.phone || ''
      companyWebsite.value = companyData.website || ''
      companyLicense.value = companyData.license_number || ''
      companyNotes.value = companyData.notes || ''
      // Prepend backend URL to relative image paths
      if (companyData.image_url && companyData.image_url.startsWith('/')) {
        const baseURL = window.location.hostname === 'localhost' 
          ? 'http://localhost:3000' 
          : `/api/v1/documents/${primaryDoc.id}/file`;
        companyImage.value = `${baseURL}${companyData.image_url}`;
      } else {
        companyImage.value = companyData.image_url || '';
      }
      isCompanyLocationValid.value = !!(companyData.address_line_1 || companyData.address)
    } else {
      // Fallback if no data found
      companyAddress.value = 'N/A'
      companyCity.value = 'N/A'
      companyState.value = 'N/A'
      companyZip.value = 'N/A'
      companyTypeDisplay.value = 'N/A'
      companyEmail.value = ''
      companyPhone.value = ''
      companyWebsite.value = ''
      companyLicense.value = ''
      companyNotes.value = ''
      isCompanyLocationValid.value = false
    }
    
  } catch (error) {
    console.error('❌ Error loading company info:', error)
    companyName.value = 'Unknown Company'
  }
}

// Load company projects with appropriate data based on company type
const loadCompanyProjects = async () => {
  try {
    console.log(`🔍 Loading projects for ${companyName.value} (${companyType.value}) (ID: ${companyId.value})...`)

    if (companyType.value === 'investor_sponsors') {
      // For investor sponsors, use OwnerAllocation data (like Directory does)
      await loadInvestorSponsorProjects()
      return
    } else if (companyType.value === 'consultants') {
      // For consultants, use ConsultantProject data (like Directory does)
      await loadConsultantProjects()
      return
    }

    // For contractors, use G702 data
    await loadContractorProjects()
  } catch (error) {
    console.error('❌ Error loading company projects:', error)
    companyProjects.value = []
  }
}

// Load contractor projects with real G702 data using dedicated API
const loadContractorProjects = async () => {
  try {
    console.log(`🔍 Loading contractor projects for ${companyName.value} (ID: ${companyId.value})...`)

    // Use the dedicated g702_performance API endpoint - much faster than scanning all projects
    let performanceData = null
    await new Promise((resolve) => {
      axiosQuery(
        `${apiBase}contractors/${companyId.value}/g702_performance`,
        authToken,
        (response) => {
          performanceData = response
          resolve()
        },
        (error) => {
          console.error(`❌ API error for contractor g702_performance:`, error)
          resolve()
        }
      )
    })

    if (!performanceData) {
      console.log(`❌ No performance data returned for contractor ${companyId.value}`)
      companyProjects.value = []
      return
    }

    console.log(`✅ Got G702 performance data:`, performanceData.summary)

    // Get all projects for additional info
    const allProjects = await DDADataService.getProjects()
    const projectsMap = new Map(allProjects.map(p => [p.id, p]))

    // Combine G702 and G703 records and group by project
    const contractorProjectData = [
      ...performanceData.g702_records.map(r => ({ ...r, projectable_id: r.project_id, source: 'g702' })),
      ...performanceData.g703_records.map(r => ({ ...r, projectable_id: r.project_id, source: 'g703' }))
    ]

    console.log(`📊 Total contractor records: ${contractorProjectData.length} (${performanceData.g702_records.length} G702, ${performanceData.g703_records.length} G703)`)

    // Get unique project IDs
    const projectIds = [...new Set(contractorProjectData.map(r => r.project_id))]
    const contractorProjects = projectIds.map(id => projectsMap.get(id)).filter(Boolean)

    console.log(`✅ Found ${contractorProjects.length} projects with G702/G703 data for contractor ${companyName.value}`)

    // Create contractor performance data using EXACT same Companies tab logic
    const contractorMap = new Map();
    
    // Process ALL G702 records for this contractor (across all projects) 
    contractorProjectData.forEach(record => {
      const projectId = record.projectable_id || record.project_id;
      const project = projectsMap.get(projectId);
      if (!project) return;
      
      const projectName = project.name || record.project_name;
      
      if (!contractorMap.has(projectName)) {
        contractorMap.set(projectName, {
          project_name: projectName,
          project_id: projectId,
          project: project,
          records: []
        });
      }
      
      contractorMap.get(projectName).records.push(record);
    });

    // Process each project using EXACT Companies tab logic
    const enhancedProjects = Array.from(contractorMap.values()).map(projectData => {
      const project = projectData.project;
      
      // Score records based on data completeness and recency (EXACT copy from Companies tab)
      const scoreRecord = (record) => {
        let score = 0;
        
        // High priority: Has actual earned amount (check both field names)
        if (parseFloat(record.total_earned_less_retainage || record.earned || 0) > 0) score += 1000;
        if (parseFloat(record.total_completed_and_stored_to_date || record.completed || 0) > 0) score += 800;
        
        // Medium priority: Has contract amounts (check both field names)
        if (parseFloat(record.contract_sum_to_date || record.contract_sum || 0) > 0) score += 500;
        if (parseFloat(record.original_contract_sum || record.original_contract || 0) > 0) score += 300;
        
        // Low priority: Has balance data
        if (parseFloat(record.balance_to_finish_including_retainage || record.balance || 0) > 0) score += 100;
        
        // Date bonus (more recent = higher score)
        const date = record.period_through ? new Date(record.period_through) : new Date(0);
        score += Math.min(date.getTime() / 1000000, 100); // Max 100 points for date
        
        return score;
      };

      // Find the BEST record for this project using the scoring function
      const latestRecord = projectData.records.reduce((best, current) => {
        return scoreRecord(current) > scoreRecord(best) ? current : best;
      }, projectData.records[0]);

      console.log(`🔍 ${project.name} - RECORD SCORING (FIXED V3):`)
      console.log(`📊 Total records to score: ${projectData.records.length}`)
      projectData.records.forEach((record, index) => {
        console.log(`🔍 Scoring Record ${index + 1} (${record.id}):`)
        
        // Debug each field individually
        const earnedField1 = record.total_earned_less_retainage;
        const earnedField2 = record.earned;
        const earnedValue = earnedField1 || earnedField2 || 0;
        console.log(`   earned fields: total_earned_less_retainage=${earnedField1}, earned=${earnedField2}, final=${earnedValue}`)
        
        const contractField1 = record.contract_sum_to_date;
        const contractField2 = record.contract_sum;
        const contractValue = contractField1 || contractField2 || 0;
        console.log(`   contract fields: contract_sum_to_date=${contractField1}, contract_sum=${contractField2}, final=${contractValue}`)
        
        const recordScore = scoreRecord(record);
        console.log(`   Final Score: ${recordScore}`)
      })
      console.log(`🔍 ${project.name} WINNER:`, {
        id: latestRecord.id,
        earned: latestRecord.total_earned_less_retainage,
        contract: latestRecord.contract_sum_to_date,
        balance: latestRecord.balance_to_finish_including_retainage
      });

      // Use EXACT same calculation logic as Companies tab (support both field names)
      const currentBudget = parseFloat(latestRecord.contract_sum_to_date || latestRecord.contract_sum || latestRecord.original_contract_sum || latestRecord.original_contract || 0);
      const balanceToFinish = parseFloat(latestRecord.balance_to_finish_including_retainage || latestRecord.balance || 0);
      
      // Use the CORRECT field that the G702 grid uses (support both field names)
      let completedToDate = parseFloat(latestRecord.total_earned_less_retainage || latestRecord.earned || 0);
      
      // If that's also 0, try total_completed_and_stored_to_date
      if (completedToDate === 0) {
        completedToDate = parseFloat(latestRecord.total_completed_and_stored_to_date || latestRecord.completed || 0);
      }
      
      // Last resort: calculate from budget - balance (ONLY if balance is meaningful)
      if (completedToDate === 0 && currentBudget > 0 && balanceToFinish > 0) {
        completedToDate = currentBudget - balanceToFinish;
      }
      
      // If balance is null/0 and no earned data, don't assume 100% complete
      if (completedToDate === 0 && balanceToFinish === 0 && !latestRecord.total_earned_less_retainage && !latestRecord.total_completed_and_stored_to_date) {
        completedToDate = 0; // Don't assume completion when data is missing
      }

      console.log(`💰 ${project.name} EXACT Companies tab calculation:`, {
        currentBudget,
        balanceToFinish,
        completedToDate,
        'completedToDate source': latestRecord.total_earned_less_retainage ? 'total_earned_less_retainage' :
                                  latestRecord.total_completed_and_stored_to_date ? 'total_completed_and_stored_to_date' :
                                  'calculated (budget - balance)'
      });

      // Calculate variance percentages using EXACT same logic as Companies tab
      const budgetVariance = currentBudget > 0 ? ((currentBudget - parseFloat(latestRecord.original_contract_sum || 0)) / parseFloat(latestRecord.original_contract_sum || currentBudget)) * 100 : 0;
      const completionPct = currentBudget > 0 ? (completedToDate / currentBudget) * 100 : 0;
      const scheduleVariance = completionPct > 100 ? completionPct - 100 : 0;

      return {
        ...project,
        // Real G702 financial data
        total_original_budget: parseFloat(latestRecord.original_contract_sum || 0),
        total_current_budget: currentBudget,
        total_billed_to_date: completedToDate,
        currentBudget: currentBudget, // Add this for totalValue calculation
        // Real calculated metrics
        budgetVariance,
        scheduleVariance,
        completionPct,
        latestPeriod: latestRecord.period_through,
        g702RecordCount: projectData.records.length,
        // Enhanced project info
        lender: project.lender || project.primary_lender || '',
        developer: project.developer || project.primary_developer || '',
        actual_start_date: project.actual_start_date || project.start_date || null, // Add for charts
      }
    })

    // Sort by latest activity (most recent G702 submissions first)
    enhancedProjects.sort((a, b) => {
      if (!a.latestPeriod && !b.latestPeriod) return 0
      if (!a.latestPeriod) return 1
      if (!b.latestPeriod) return -1
      return new Date(b.latestPeriod) - new Date(a.latestPeriod)
    })

    companyProjects.value = enhancedProjects
    console.log(`✅ Enhanced projects with real G702 data: ${enhancedProjects.length}`)
    
    // Debug: Log project data for charts
    console.log('📊 Project data for charts:', enhancedProjects.map(p => ({
      name: p.name,
      currentBudget: p.currentBudget,
      budgetVariance: p.budgetVariance,
      scheduleVariance: p.scheduleVariance,
      actual_start_date: p.actual_start_date
    })))

    // Populate detailed performance data for the second tab
    const detailedPerformanceRecords = []
    contractorProjectData.forEach(g702 => {
      const projectId = g702.projectable_id || g702.project_id
      const project = projectsMap.get(projectId)
      detailedPerformanceRecords.push({
        ...g702,
        project_name: project?.name || g702.project_name || 'Unknown Project',
        project_id: projectId,
        // PRIORITY: Use description from G703, then scope_detail from G702
        dda_term: g702.description || g702.scope_detail || 'Not Assigned'
      })
    })

    // Sort detailed performance by project name, then by latest period
    detailedPerformanceRecords.sort((a, b) => {
      const projectCompare = (a.project_name || '').localeCompare(b.project_name || '')
      if (projectCompare !== 0) return projectCompare
      
      const dateA = new Date(a.period_through || '1900-01-01')
      const dateB = new Date(b.period_through || '1900-01-01')
      return dateB - dateA // Newest first within each project
    })

    contractorPerformanceData.value = detailedPerformanceRecords
    console.log(`✅ Populated ${detailedPerformanceRecords.length} detailed performance records`)

    // Build relationships overview based on actual project participation with frequency counts
    try {
      const capitalCounts = new Map()
      const managementCounts = new Map()
      const contractorCounts = new Map()

      enhancedProjects.forEach(p => {
        if (p.lender && p.lender !== companyName.value) {
          capitalCounts.set(p.lender, (capitalCounts.get(p.lender) || 0) + 1)
        }
        if (p.developer && p.developer !== companyName.value) {
          managementCounts.set(p.developer, (managementCounts.get(p.developer) || 0) + 1)
        }
        if (p.project_general_contractor && p.project_general_contractor !== companyName.value) {
          contractorCounts.set(p.project_general_contractor, (contractorCounts.get(p.project_general_contractor) || 0) + 1)
        }
      })

      // Get top 5 most frequent collaborators for each category with counts
      relationships.capital = Array.from(capitalCounts.entries())
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name, count]) => `${name} (${count})`)
        
      relationships.management = Array.from(managementCounts.entries())
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name, count]) => `${name} (${count})`)
        
      relationships.contractors = Array.from(contractorCounts.entries())
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name, count]) => `${name} (${count})`)
        
      console.log(`🤝 Built relationships with counts - Capital: ${relationships.capital.length}, Management: ${relationships.management.length}, Contractors: ${relationships.contractors.length}`)
    } catch (error) {
      console.error('❌ Error building relationships:', error)
    }
    
  } catch (error) {
    console.error('❌ Error loading company projects:', error)
    companyProjects.value = []
  }
  
  // Initialize the projects map after loading data
  setTimeout(() => {
    initializeContractorProjectsMap()
  }, 500)
}

// Fetch G702 contractor data across all projects for this specific contractor
const fetchContractorDataAcrossProjects = async (projectIds) => {
  try {
    console.log(`🔥 Fetching G702 data across ${projectIds.split(',').length} projects for contractor ID: ${companyId.value}`)
    
    const response = await fetch(`${apiBase}projects/fetch_project_g703?project_ids=${projectIds}`, {
      headers: authToken.value
    })
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`)
    }
    
    const data = await response.json()
    console.log(`📊 G702 API Response:`, data)
    
    // Extract contractor data using EXACT same logic as Companies tab
    let allContractors = [];
    
    if (data && (data.subcontractor_g702s || data.extracted_g702s)) {
      // EXACT COPY of G702 grid logic from Companies tab
      const subs = data.subcontractor_g702s || [];
      const extracted = data.extracted_g702s || [];
      console.log(`🔥 G702 DATA: Found ${subs.length} subcontractor G702s + ${extracted.length} extracted G702s`);
      
      // Combine traditional subcontractor data with extracted contractor data (EXACT copy)
      allContractors = [...subs, ...extracted];
      
      // Sort like G702 grid: by contractor name, then by date (newest first)
      allContractors = allContractors.sort((a, b) => {
        const nameA = (a.contractor_name || '').toLowerCase();
        const nameB = (b.contractor_name || '').toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB);
        }
        const dateA = new Date(a.period_through || a.period_to || '1900-01-01');
        const dateB = new Date(b.period_through || b.period_to || '1900-01-01');
        return dateB - dateA; // Newest first
      });
      
      console.log('📊 Using EXACT G702 grid logic:', allContractors.length, 'total contractors');
    } else if (data && data.all_contractors) {
      // Fallback: Use all_contractors if available
      allContractors = data.all_contractors;
      console.log('📊 Fallback to all_contractors:', allContractors.length, 'contractors');
    } else {
      console.error('❌ No contractor data found in response:', data);
      allContractors = [];
    }
    
    console.log(`📊 Total contractor records found: ${allContractors.length}`)
    
    // Filter to only this contractor's records using contractor_id (much more reliable!)
    const targetContractorId = parseInt(companyId.value)
    console.log(`🎯 Filtering for contractor_id: ${targetContractorId}`)
    
    // Log all unique contractor IDs to see what's available
    const uniqueIds = [...new Set(allContractors.map(c => c.contractor_id).filter(Boolean))]
    console.log(`📋 Available contractor IDs:`, uniqueIds)
    
    const filteredRecords = allContractors.filter(contractor => {
      const contractorId = parseInt(contractor.contractor_id)
      const isMatch = contractorId === targetContractorId
      
      if (isMatch) {
        console.log(`✅ MATCH: contractor_id ${contractorId} matches target ${targetContractorId}`)
        console.log(`   - Contractor Name: "${contractor.contractor_name}"`)
        console.log(`   - Contract Sum: $${contractor.contract_sum_to_date || contractor.original_contract_sum || 0}`)
        console.log(`   - Billed Amount: $${contractor.total_earned_less_retainage || contractor.total_completed_and_stored_to_date || 0}`)
        console.log(`   - Project ID: ${contractor.projectable_id}`)
        console.log(`   - Available fields:`, Object.keys(contractor))
        console.log(`   - Financial fields check:`)
        console.log(`     * total_earned_less_retainage: ${contractor.total_earned_less_retainage}`)
        console.log(`     * total_completed_and_stored_to_date: ${contractor.total_completed_and_stored_to_date}`)
        console.log(`     * current_payment_due: ${contractor.current_payment_due}`)
        console.log(`     * balance_to_finish_including_retainage: ${contractor.balance_to_finish_including_retainage}`)
        console.log(`   - Raw G702 data:`, contractor)
      }
      
      return isMatch
    })
    
    console.log(`✅ Filtered to ${filteredRecords.length} records for contractor ID: ${targetContractorId}`)
    
    // Debug: Let's see what we're missing - show all contractor records with IDs
    console.log(`🔍 DEBUG: All contractor records breakdown:`)
    const contractorCounts = {}
    allContractors.forEach(c => {
      const id = c.contractor_id
      const name = c.contractor_name
      if (!contractorCounts[id]) contractorCounts[id] = { name, count: 0, records: [] }
      contractorCounts[id].count++
      contractorCounts[id].records.push({
        project: c.projectable_id,
        contract_sum: c.contract_sum_to_date,
        earned: c.total_earned_less_retainage,
        completed: c.total_completed_and_stored_to_date,
        balance: c.balance_to_finish_including_retainage
      })
    })
    console.log(`📊 Contractor breakdown:`, contractorCounts)
    
    return filteredRecords
    
  } catch (error) {
    console.error('❌ Error fetching contractor G702 data:', error)
    return []
  }
}


// Initialize data
onMounted(async () => {
  console.log('🚀 CompanyProfileView mounted - START')
  
  console.log('🔧 Route params:', route.params)
  console.log('🔧 Company type:', companyType.value)
  console.log('🔧 Company ID:', companyId.value)
  
  await loadCompanyInfo()
  await loadCompanyProjects()
  
  console.log('🔧 After loading data, company details:', {
    name: companyName.value,
    address: companyAddress.value,
    city: companyCity.value,
    state: companyState.value,
    zip: companyZip.value
  })
  
  // Initialize Google Maps
  console.log('🗺️ Starting Google Maps API loading...')
  loadGoogleMapsAPI.then(() => {
    console.log('🗺️ Google Maps API loaded successfully, calling loadGoogleMaps()')
    loadGoogleMaps()
  }).catch((error) => {
    console.error('❌ Failed to load Google Maps API:', error)
  })
  
  isDataLoaded.value = true
  console.log('✅ Company profile data loaded - COMPLETE')
})

// Watch for route changes
watch(() => route.params, async (newParams) => {
  if (newParams.type && newParams.id) {
    console.log('🔄 Route changed, reloading data for:', newParams)
    companyType.value = newParams.type
    companyId.value = newParams.id
    isDataLoaded.value = false
    
    await loadCompanyInfo()
    await loadCompanyProjects()
    
    // Reload map with new company data
    if (isGoogleMapsMounted.value) {
      setTimeout(() => {
        loadGoogleMapsFromAddress()
      }, 500)
    }
    
    isDataLoaded.value = true
  }
}, { immediate: false })

// Ensure map renders when user switches to Map tab (container exists only then)
watch(sidebarSelectedItemId, async (val) => {
  if (val === 2) {
    try {
      await loadGoogleMapsAPI
      // Defer to next tick so #individualPageMap is in DOM
      setTimeout(() => loadGoogleMaps(), 0)
    } catch (_) { /* ignore */ }
  }
})
</script>

<style scoped lang="scss">
@import "@/assets/colors.scss";

// EXACT ProjectSummary styles
.individual-page-container {
  display: flex;
  height: 100vh;
  width: 100%;
  margin-top: 53px;
  font-family: 'Inter';
}

.individual-page-sidebar {
  width: 280px;
  min-height: 100vh;
  transition: all 0.3s ease;
  border-right: 1px solid #e0e0e0;
  position: relative;
  background: white;
  
  &.open {
    transform: translateX(0);
    width: 280px;
  }
  
  &.closed {
    transform: translateX(0);
    width: 40px;
    
    // Ensure ExpandCollapse button stays visible and clickable
    .expand-collapse {
      position: relative;
      z-index: 100;
      }
    }
  }
  
.project-name {
  padding: 20px 15px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  strong {
    font-size: 18px;
    color: #333;
    font-weight: 600;
  }
}

.menu-container {
  position: relative;
  
  .menu-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    color: #666;
    
    &:hover {
      color: #333;
    }
  }
  
  .menu-content {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    z-index: 1000;
    min-width: 180px;
    
    ul {
      list-style: none;
      margin: 0;
      padding: 8px 0;
      
      li {
        padding: 8px 16px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
        
        &:hover {
          background: #f5f5f5;
  }
}
    }
  }
}

// EXACT sidebar menu styling from ProjectSummary
.sidebar-menu {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid $mediumGray1;
  font-size: 12px;
  font-weight: lighter;
  padding: 0 15px;
  margin-top: 15px;

  div {
    cursor: pointer;
    padding: 5px 5px 5px 0px;
    margin-right: 10px;
  }
}

.sidebar-menu-selected {
  font-weight: bold;
  border-bottom: 3px solid $brightBlue1;
  color: $brightBlue1;
}

.project-img {
  padding: 15px;
  text-align: center;
  
  img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
  border-radius: 8px;
  }
  
  .placeholder-image {
    background: #f5f5f5;
    border: 2px dashed #ddd;
    border-radius: 8px;
    padding: 40px 20px;
    color: #999;
    
    span {
      font-size: 32px;
      display: block;
      margin-bottom: 10px;
    }
  }
}

.map-container {
  padding: 15px;
  height: 200px;
  
  #individualPageMap {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}

.project-details-wrapper {
  padding: 15px;
}

.project-details {
  font-size: 12px;
}

.project-img-summary {
  .project-img-summary-item {
  display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
  
  label {
      font-weight: 500;
    color: #666;
  }
  
  span {
    color: #333;
      text-align: right;
    }
  }
}

// Building details container (company details)
.building-details-container {
  padding: 15px 0;
  border-bottom: 2px solid $lightGray1;
}

.accordion-panel-header {
  display: flex;
  align-items: center;
  position: relative;
  width: 97%;
  height: 27px;
  margin-top: 5px;
  margin-bottom: 10px;

  label {
    font-size: 16px;
    font-weight: bold;
  }
}

.building-details-summary {
  .building-details-summary-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    
    label {
      font-weight: 500;
      color: #666;
    }
    
    span {
      color: #333;
      text-align: right;
    }
  }
}

// Content area
.individal-page-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  
  &.large {
    margin-left: 40px;
  }
  
  &.small {
    margin-left: 0;
  }
}

.breadcrumbs {
  font-size: 14px;
  color: $mediumGray1;
  margin-bottom: 10px;
  
  .breadcrumb-link {
    color: #4A5FD5;
    cursor: pointer;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.individual-page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.individual-page-sub-menu {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 30px;
  
  div {
    padding: 12px 24px;
    cursor: pointer;
    font-weight: 500;
    color: #666;
    border-bottom: 3px solid transparent;
    
    &.individual-page-sub-menu-selected {
      color: #4A5FD5;
      border-bottom-color: #4A5FD5;
    }
  }
}

.budget-summary-header-container {
  margin-bottom: 20px;
  
  .budget-summary-header-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }
}

.overview-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  
  .stat-tile {
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 24px 20px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), 0 3px 8px rgba(0, 0, 0, 0.06);
    }
    
    .stat-title {
      font-size: 12px;
      color: #6b7280;
      font-weight: 600;
      margin-bottom: 12px;
      text-transform: uppercase;
      letter-spacing: 0.8px;
    }
    
    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: #1f2937;
      letter-spacing: -0.5px;
    }
  }
}

.charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
  
  .chart-container {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    
    h3 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #333;
    }
    
    .chart-placeholder {
      height: 200px;
      background: #f8f9fa;
      border: 2px dashed #ddd;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-style: italic;
    }
  }
}

.projects-grid-container {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #333;
  }
}

.relationships-section {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #333;
  }
}

.relationships-overview { background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 16px; }
.relationships-overview .section-title { font-weight: 600; color: #333; margin-bottom: 12px; }
.overview-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.overview-col { border: 1px dashed #e5e7eb; border-radius: 8px; padding: 12px; min-height: 160px; }
.col-title { font-weight: 600; margin-bottom: 8px; color: #4A5FD5; }
.link-list { margin: 0; padding-left: 18px; }
.link-list li { margin: 2px 0; }
.muted { color: #9ca3af; }

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  
  .partner-card {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    
    h4 {
    font-size: 16px;
    font-weight: 600;
      margin-bottom: 10px;
      color: #333;
  }
  
  p {
    color: #666;
      margin: 0;
    }
  }
}

// Loading state
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f8f9fa;
  
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e0e0e0;
    border-top: 4px solid #4A5FD5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
  }
  
  p {
    color: #666;
    font-size: 16px;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.hidden {
  display: none;
}

// Modal styles
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.edit-project-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e0e0e0;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;

    h3 {
      margin: 0;
      color: #333;
      font-size: 18px;
    font-weight: 600;
    }

    .close-button {
      background: none;
      border: none;
      font-size: 24px;
      color: #666;
      cursor: pointer;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.2s ease;

      &:hover {
        background: #e0e0e0;
        color: #333;
      }
    }
  }

  .modal-body {
    padding: 24px;
  }

  .form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-group {
    flex: 1;

    label {
      display: block;
    font-weight: 500;
      color: #333;
      margin-bottom: 6px;
      font-size: 14px;
    }

    .form-input {
      width: 100%;
      padding: 10px 12px;
      border: 2px solid #ddd;
      border-radius: 6px;
      font-size: 14px;
      outline: none;
      transition: all 0.2s ease;
      box-sizing: border-box;

      &:focus {
        border-color: #4A5FD5;
        box-shadow: 0 0 0 3px rgba(74, 95, 213, 0.1);
      }
    }
  }

  .form-section {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
  }

  .modal-footer {
  display: flex;
  justify-content: space-between;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid #e0e0e0;
    background: #f8f9fa;

    .btn-secondary {
      padding: 10px 20px;
      border: 2px solid #ddd;
      background: white;
    color: #666;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover {
        border-color: #bbb;
        color: #333;
      }
    }

    .btn-primary {
      padding: 10px 20px;
      border: 2px solid #4A5FD5;
      background: #4A5FD5;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover {
        background: #3949a8;
        border-color: #3949a8;
      }
    }
  }
  }

.modal-footer.split { align-items: center; }
.modal-footer.split .left { flex: 1; }
.modal-footer.split .right { display: flex; gap: 12px; }
  
.edit-images-modal {
  background: white;
  border-radius: 8px;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  
  /* Make image modal footer/buttons match edit-project modal */
  .modal-footer {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid #e0e0e0;
    background: #f8f9fa;
  }
  .btn-secondary {
    padding: 10px 20px;
    border: 2px solid #ddd;
    background: white;
    color: #666;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    &:hover { border-color: #bbb; color: #333; }
  }
  .btn-primary {
    padding: 10px 20px;
    border: 2px solid #4A5FD5;
    background: #4A5FD5;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    &:hover { background: #3949a8; border-color: #3949a8; }
  }
  
  .modal-header {
    text-align: center;
    position: relative;
    
    .close-button {
      position: absolute;
      top: 15px;
      right: 20px;
      background: none;
      border: none;
    font-size: 24px;
      cursor: pointer;
      color: #666;
      line-height: 1;
      
      &:hover {
        color: #333;
      }
    }
    
    h3 {
      margin: 0;
      padding: 20px;
      font-size: 20px;
    font-weight: 600;
      color: #333;
    }
  }
  
  .modal-body {
    padding: 0 30px 20px 30px;
    overflow-y: auto;
    flex: 1;
  }
}

.upload-section {
  text-align: center;
  padding: 20px;
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  margin-bottom: 20px;
  background: #f8f9fa;
}

.upload-button {
  display: inline-block;
  padding: 12px 24px;
  background: #4A5FD5;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background: #3a4fc2;
  }
}

.upload-hint {
  margin: 10px 0 0 0;
  color: #666;
  font-size: 14px;
}

.images-section {
  margin-bottom: 30px;
  
  h4 {
  font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 25px 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
  }
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.image-item {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #4A5FD5;
    box-shadow: 0 4px 12px rgba(74, 95, 213, 0.15);
  }
}

.image-preview {
  position: relative;
  aspect-ratio: 16/9;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/* Portfolio 3-Column Dashboard */
.dashboard-three-column {
  display: flex;
  gap: 20px;
  margin: 20px 0;
  height: 400px;
}

.dashboard-tile {
  background: white;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), 0 3px 8px rgba(0, 0, 0, 0.06);
  }
}

.map-tile {
  flex: 1.2;
  padding: 0;
}

#contractorDataMap {
  height: 100%;
  border-radius: 12px;
}

.doughnut-tile {
  flex: 1.2;
}

.variance-and-starts-tile {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  padding: 15px;
}

.tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.chart-badge {
  background: #3b82f6;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
}

.doughnut-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 15px;
}

.doughnut-chart-wrapper {
  flex-shrink: 0;
}

.doughnut-chart-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-label {
  flex: 1;
  color: #6b7280;
}

.legend-value {
  font-weight: 600;
  color: #374151;
}

.chart-placeholder {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 16px;
}

.variance-chart-wrapper {
  flex: 1;
  position: relative;
  min-height: 0;
}

.variance-top-section {
  display: flex;
  gap: 10px;
  height: 180px;
  flex-shrink: 0;
}

.variance-chart {
  width: 50%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px;
  min-height: 0;
  
  .variance-subtitle {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6B7280;
    margin-bottom: 6px;
    text-align: center;
    flex-shrink: 0;
  }
  
  .chart-container {
    flex: 1;
    min-height: 0;
    max-height: 140px;
    
    canvas {
      max-height: 140px !important;
      width: 100% !important;
    }
  }
}

.project-starts-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px;
  min-height: 0;
  
  .variance-subtitle {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6B7280;
    margin-bottom: 8px;
    text-align: center;
  }
  
  .chart-container {
    flex: 1;
    position: relative;
    min-height: 0;
    
    &.project-starts-chart {
      height: 100%;
    }
  }
  
  .project-stats-row {
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
    font-size: 0.75rem;
    color: #6B7280;
    
    .stat-text {
      strong {
        color: #1f2937;
        font-weight: 700;
      }
    }
  }
}

.compact-header {
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.minimal-header {
  padding: 5px 0;
}
</style> 
